import {TableBodyCell, TableBodyCellText} from '@/components/ui/table-atoms/TableAtoms'
import styled, {css} from 'styled-components'

export const StyledPatientsWrapper = styled.div(
    ({theme: {palette}}) => css`
        display: grid;
        grid-template-rows: auto auto minmax(0, 1fr);
        background-color: ${palette.neutral['white']};
        height: 100%;
        border-radius: 8px 8px 0 0;
        border: 1px solid ${palette.neutral[200]};
    `
)

export const StyledSelectCell = styled.div(
    ({theme: {spacing, palette}}) => css`
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: ${spacing * 2}px;
        width: 100%;
        padding: ${spacing * 0.5}px;

        & svg {
            fill: ${palette.orange['600']};
        }
    `
)

export const StyledContactCell = styled(TableBodyCell)(
    () => css`
        display: flex;
        justify-content: center;
        align-items: flex-start;
        flex-direction: column;
        overflow: hidden;
        & p {
            max-width: 100%;
        }
    `
)

export const StyledStatusCell = styled(TableBodyCellText)(
    ({theme: {spacing, palette}}) => css`
        display: flex;
        align-items: center;
        gap: ${spacing * 2}px;
        width: 100%;
        & > svg {
            fill: ${palette.success[500]};
        }
    `
)
